import { jsx as a, jsxs as i } from "react/jsx-runtime";
function t(v) {
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "512",
      height: "512",
      x: "0",
      y: "0",
      viewBox: "0 0 64 64",
      className: "",
      fill: "rgb(var(--fill-primary))",
      ...v,
      children: /* @__PURE__ */ i("g", { children: [
        /* @__PURE__ */ a(
          "path",
          {
            d: "M44.987 46.887a21.208 21.208 0 0 0 2.669-9.456v-9.75a3.878 3.878 0 0 0-5.908-3.305 3.979 3.979 0 0 0-6.12-2.173 3.98 3.98 0 0 0-5.652-1.914v-7.965a4.183 4.183 0 0 0-8.365 0v14.009a8.414 8.414 0 0 0-4.94 5.277c-1.354 4.67 1.737 10.36 4.57 14.312a11.57 11.57 0 0 1 2.18 6.572h-1.417a1 1 0 0 0-1 1V59a1 1 0 0 0 1 1h23.237a1 1 0 0 0 1-1v-5.506c-.056-1.353-1.645-.94-2.526-1a11.511 11.511 0 0 1 1.272-5.607zM44.241 58H23.004v-3.506h21.237zm-18.813-5.506a13.568 13.568 0 0 0-2.562-7.738c-2.107-2.94-5.464-8.485-4.274-12.588a6.032 6.032 0 0 1 3.019-3.59v6.528a1 1 0 0 0 2 0V12.324a2.182 2.182 0 0 1 4.365 0v18.439a1 1 0 0 0 2 0V23.74a1.98 1.98 0 1 1 3.96 0v7.527a1 1 0 0 0 2 0v-5.81a1.98 1.98 0 1 1 3.961 0v6.112a1 1 0 0 0 2 0v-3.89a1.88 1.88 0 0 1 3.759 0v9.75c.067 6.076-4.235 9.383-3.94 15.064z",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ a(
          "path",
          {
            d: "M19.075 13.274a1 1 0 0 0 1-1v-.606c.238-7.491 11.099-7.488 11.336 0v.41a1 1 0 0 0 2 0v-.41c-.386-10.16-14.953-10.155-15.336 0v.606a1 1 0 0 0 1 1z",
            "data-original": "#000000"
          }
        )
      ] })
    }
  );
}
export {
  t as TapIcon
};
